import {HttpModelConverter} from '../../../../../../core/converter/httpModel.converter';
import {PaymentRequestModel} from '../paymentRequest.model';
import {PaymentRequestSummaryConverter} from './paymentRequestSummary.converter';
import {SaleSummaryConverter} from '../../../../../api/entity/converter/saleSummary.converter';
import {Injectable} from '@angular/core';
import {
    PaymentRequestReminderSummaryConverter
} from "../../../reminder/api/entity/converter/paymentRequestReminderSummary.converter";


@Injectable({providedIn: 'root'})
export class PaymentRequestConverter extends HttpModelConverter<PaymentRequestModel> {


    constructor(private paymentRequestSummaryConverter: PaymentRequestSummaryConverter,
                private saleSummaryConverter: SaleSummaryConverter,
                private reminderSummaryConverter: PaymentRequestReminderSummaryConverter) {
        super();
    }

    protected createInstance(): PaymentRequestModel {
        return new PaymentRequestModel();
    }

    protected enrichObject(result: PaymentRequestModel, src: PaymentRequestModel) {
        result.summary = this.paymentRequestSummaryConverter.convert(src.summary);
        result.sale = this.saleSummaryConverter.convert(src.sale);
        result.reminders = this.reminderSummaryConverter.convertFromArray(src.reminders);
        result.groupedChildren = this.paymentRequestSummaryConverter.convertFromArray(src.groupedChildren)
    }
}
